var LoggerService;
(function (LoggerService) {
    LoggerService.error = (msg, ...optionalParams) => {
        const processLog = optionalParams.find((param) => param instanceof ProcessLog);
        const otherParams = optionalParams.filter((param) => !(param instanceof ProcessLog));
        console.error("[error] ", msg, ...otherParams);
        if (processLog) {
            const additionalParams = otherParams.map((param) => typeof param === "object" ? JSON.stringify(param) : param);
            processLog.addLog("[error] " + msg + " " + additionalParams.join(" "));
        }
    };
    LoggerService.warn = (msg, ...optionalParams) => {
        const processLog = optionalParams.find((param) => param instanceof ProcessLog);
        const otherParams = optionalParams.filter((param) => !(param instanceof ProcessLog));
        console.warn("[warn] ", msg, ...otherParams);
        if (processLog) {
            const additionalParams = otherParams.map((param) => typeof param === "object" ? JSON.stringify(param) : param);
            processLog.addLog("[warn] " + msg + " " + additionalParams.join(" "));
        }
    };
    LoggerService.info = (msg, ...optionalParams) => {
        const processLog = optionalParams.find((param) => param instanceof ProcessLog);
        const otherParams = optionalParams.filter((param) => !(param instanceof ProcessLog));
        console.info("[info] ", msg, ...otherParams);
        if (processLog) {
            const additionalParams = otherParams.map((param) => typeof param === "object" ? JSON.stringify(param) : param);
            processLog.addLog("[info] " + msg + " " + additionalParams.join(" "));
        }
    };
    LoggerService.debug = (msg, ...optionalParams) => {
        const processLog = optionalParams.find((param) => param instanceof ProcessLog);
        const otherParams = optionalParams.filter((param) => !(param instanceof ProcessLog));
        console.log("[debug] ", msg, ...otherParams);
        if (processLog) {
            const additionalParams = otherParams.map((param) => typeof param === "object" ? JSON.stringify(param) : param);
            processLog.addLog("[debug] " + msg + " " + additionalParams.join(" "));
        }
    };
    class ProcessLog {
        processName;
        logs;
        success;
        error;
        constructor({ logs, processName, success, error, }) {
            this.logs = logs ?? [];
            this.success = success;
            this.error = error;
            this.processName = processName;
        }
        addLog = (log) => {
            this.logs.push(log);
        };
        setResult = (success, error) => {
            this.success = success;
            this.error = error;
        };
        dumpProcessLog = (destinationUrl, userContext) => {
            LoggerService.info("Dumping process Log...");
            fetch(destinationUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    text: `${this.processName} Log for: ${userContext?.user.name} \n
            #######################\n\n
            ${this.logs.map((log) => `${log}`).join("\n")}
            \n
            #######################\n\n
            ${this.success ? `Success: ${this.success}` : ""}
            ${this.success ? `Error: ${this.error}` : ""}
          `,
                }),
            });
        };
    }
    LoggerService.ProcessLog = ProcessLog;
})(LoggerService || (LoggerService = {}));
export default LoggerService;
//# sourceMappingURL=logger.service.js.map